<template>
  <main>
    <LoaderAnimation v-if="loading" />
    <!-- <vue-pdf-app
      file-name="NRoom Non-disclosure Agreement"
      v-show="!loading"
      pdf="/M-in8 NDA for NRoom.pdf"
      :config="config"
      @pages-rendered="loading = false"
    ></vue-pdf-app> -->
    <iframe
      v-show="!loading"
      :src="'/M-in8 NDA for NRoom.pdf'"
      frameborder="0"
      @load="loading = false"
    ></iframe>
  </main>
</template>

<script>
import { LoaderAnimation } from "@/components";
import { detectMobile } from "@/utils/mobile-detection";
import "vue-pdf-app/dist/icons/main.css";
export default {
  name: "NDA",
  components: {
    LoaderAnimation,
  },
  data() {
    return {
      config: {
        sidebar: {
          viewThumbnail: true,
          viewOutline: true,
          viewAttachments: false,
        },
        toolbar: {
          toolbarViewerLeft: { findbar: false },
          toolbarViewerRight: {
            presentationMode: true,
            openFile: false,
            print: false,
            download: false,
            viewBookmark: true,
          },
        },
        secondaryToolbar: false,
      },
      loading: true,
      documentPath: null,
    };
  },
  computed: {
    isMobile() {
      return detectMobile();
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-app.dark {
  --pdf-app-background-color: #141414;
  --pdf-sidebar-content-color: #141414;
  --pdf-toolbar-sidebar-color: #141414;
  --pdf-toolbar-color: #141414;
  --pdf-loading-bar-color: #606c88;
  --pdf-loading-bar-secondary-color: #11ece5;
  --pdf-find-results-count-color: #d9d9d9;
  --pdf-find-results-count-font-color: #525252;
  --pdf-find-message-font-color: #a6b7d0;
  --pdf-not-found-color: #f66;
  --pdf-split-toolbar-button-separator-color: #fff;
  --pdf-toolbar-font-color: #d9d9d9;
  --pdf-button-hover-font-color: #11ece5;
  --pdf-button-toggled-color: #606c88;
  --pdf-horizontal-toolbar-separator-color: #fff;
  --pdf-input-color: #333;
  --pdf-input-font-color: #d9d9d9;
  --pdf-find-input-placeholder-font-color: #11ece5;
  --pdf-thumbnail-selection-ring-color: hsla(0, 0%, 100%, 0.15);
  --pdf-thumbnail-selection-ring-selected-color: hsla(0, 0%, 100%, 0.3);
  --pdf-error-wrapper-color: #e50914;
  --pdf-error-more-info-color: #d9d9d9;
  --pdf-error-more-info-font-color: #000;
  --pdf-overlay-container-color: rgba(0, 0, 0, 0.2);
  --pdf-overlay-container-dialog-color: #24364e;
  --pdf-overlay-container-dialog-font-color: #d9d9d9;
  --pdf-overlay-container-dialog-separator-color: #fff;
  --pdf-dialog-button-font-color: #d9d9d9;
  --pdf-dialog-button-color: #606c88;
}

#vuePdfApp {
  height: calc(100vh - 187px) !important;

  @media (min-width: 1024px) {
    height: calc(100vh - 70px) !important;
  }
}

/deep/ #outerContainer {
  #toolbarViewer {
    padding: 0 4vw;
  }

  #thumbnailView {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent;
      display: none;
    }
  }

  #errorWrapper {
    padding: 10px 4vw;
    font-size: 1.2rem;

    #errorMessage {
      margin-right: 10px;
    }

    button {
      border-radius: 12px;
      padding: 5px 10px;
      font-size: 1.2rem;
    }
  }
}

iframe {
  width: 100%;
  height: 100vh;
}

/deep/ .loading {
  height: calc(100vh - 70px);
}
</style>
